// extracted by mini-css-extract-plugin
export var deleteModal = "_ep-0";